const Page404 = () => {
  return (
    <>
      <div id='oopss'>
    <div id='error-text'>
        <img src="https://cdn.rawgit.com/ahmedhosna95/upload/1731955f/sad404.svg" alt="404"></img>
        <span>404 PAGE</span>
    </div>
</div>
  
    </>
  );
};

export default Page404;
